module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Topbar",
    style: ({
      background: _vm.skinColor
    })
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showAsideMenu($event)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "hasMsg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showAsideMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.at),
      expression: "at"
    }],
    staticClass: "msg-count"
  }, [_vm._v(_vm._s(_vm.msgCount))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "logo-text color-blue"
  }, [_vm._v("C")]), _vm._v(" "), _c('span', {
    staticClass: "logo-text color-red"
  }, [_vm._v("N")]), _vm._v(" "), _c('span', {
    staticClass: "logo-text color-yellow"
  }, [_vm._v("o")]), _vm._v(" "), _c('span', {
    staticClass: "logo-text color-green"
  }, [_vm._v("d")]), _vm._v(" "), _c('span', {
    staticClass: "logo-text color-orange"
  }, [_vm._v("e")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6fc86a40"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar/Topbar.vue
// module id = 334
// module chunks = 4